export default "---\nname: \"Champion's Favor\"\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"